import React, { useState, useEffect } from 'react';

const LoadingCards = ({ count = 3, showDots = false }) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    if (!showDots) return;
    
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);
    
    return () => clearInterval(interval);
  }, [showDots]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {[...Array(count)].map((_, index) => (
        <div key={index} className="bg-white rounded-lg shadow-lg border border-gray-200 p-6">
          <div className="flex flex-col items-center justify-center space-y-4">
            <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="h-6 w-40 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-12 w-24 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
      ))}
      {showDots && (
        <div className="col-span-full text-center text-gray-500 mt-4">
          Loading{dots}
        </div>
      )}
    </div>
  );
};

export default LoadingCards;